// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3crm5","left":"styles_left__1n4nz"};